// components/teams/modals/EmergencyContactsModal.jsx
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import SubmitButton from '../../../forms/formComponents/SubmitButton';

function Field({ label, value }) {
if (!value) return null;
return (
<div style={{ marginBottom: 6 }}>
<div style={{ fontSize: '0.8rem', opacity: 0.7 }}>{label}</div>
<div style={{ fontWeight: 600 }}>{value}</div>
</div>
);
}

export default function EmergencyContactsModal({
memberName,
memberPhone = '',
contacts = [],
onClose
}) {
return ReactDOM.createPortal(
<div className="modal-backdrop">
<div className="modal-content" role="dialog" aria-modal="true" aria-label={`${memberName}'s emergency contacts`}>
<h2 className="modal-title">Emergency contacts for {memberName}</h2>

{memberPhone && (
<div className="card" style={{ padding: '0.8rem', marginTop: 8, marginBottom: 12 }}>
<h3 style={{ margin: 0, marginBottom: 8 }}>Member contact number</h3>
<Field label="Phone" value={memberPhone} />
</div>
)}

{(!contacts || contacts.length === 0) && (
<p style={{ marginTop: 8 }}>No emergency contacts have been provided.</p>
)}

{contacts && contacts.length > 0 && (
<div style={{ display: 'grid', gap: '12px', marginTop: 8 }}>
{contacts.map((c, idx) => (
<div key={idx} className="card" style={{ padding: '0.8rem' }}>
<h3 style={{ margin: 0, marginBottom: 8 }}>Contact {idx + 1}</h3>
<Field label="Full name" value={c?.name} />
<Field label="Relationship" value={c?.relationship} />
<Field label="Phone" value={c?.phone} />
<Field label="Alternate phone" value={c?.alternatePhone} />
<Field label="Email" value={c?.email} />
<Field label="Address" value={c?.address} />
</div>
))}
</div>
)}

<div className="form-actions" style={{ marginTop: 16 }}>
<SubmitButton type="button" onClick={onClose} label="Close" />
</div>
</div>
</div>,
document.body
);
}

EmergencyContactsModal.propTypes = {
memberName: PropTypes.string.isRequired,
memberPhone: PropTypes.string,
contacts: PropTypes.arrayOf(
PropTypes.shape({
name: PropTypes.string,
relationship: PropTypes.string,
phone: PropTypes.string,
address: PropTypes.string,
email: PropTypes.string,
alternatePhone: PropTypes.string,
})
),
onClose: PropTypes.func.isRequired,
};
